var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.navType === 1 ? "yxtf-checkbox" : "yxt-checkbox",
    {
      ref: "checkbox",
      tag: "component",
      class: _vm.className,
      attrs: { disabled: _vm.disabled, label: _vm.label },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }